module.exports = __webpack_public_path__ + "img/img_elanco_header_logo.7525df31.svg";